import { get, post } from '@/libraries/axios'

// 注册
export const registerapi = (data) => post('user/register', data)

// 账号登录
export const pwdloginapi = (data) => post('user/pwdlogin', data)

